import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ModalController } from '@ionic/angular';

interface SendDocumentFormGroup {
  email: FormControl<string | null>;
  message: FormControl<string | null>;
  subject: FormControl<string | null>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-send-document-modal',
  standalone: false,
  styleUrls: ['./send-document-modal.component.scss'],
  templateUrl: './send-document-modal.component.html'
})
export class SendDocumentModalComponent {
  private modalController = inject(ModalController);

  form: FormGroup<SendDocumentFormGroup> = new FormGroup<SendDocumentFormGroup>({
    email: new FormControl<string>('', [Validators.required, Validators.email, Validators.maxLength(254)]),
    message: new FormControl<string>('', [Validators.maxLength(300)]),
    subject: new FormControl<string>('', [Validators.required, Validators.maxLength(78)])
  });

  emailValue = '';

  set email(value: string) {
    this.emailValue = value;
    this.form.controls.email.setValue(value);
  }

  get email() {
    return this.emailValue;
  }

  subjectValue = '';

  set subject(value: string) {
    this.subjectValue = value;
    this.form.controls.subject.setValue(value);
  }

  get subject() {
    return this.subjectValue;
  }

  cancel() {
    return this.modalController.dismiss(null, 'cancel');
  }

  send() {
    const { email, message, subject } = this.form.getRawValue();
    return this.modalController.dismiss(
      {
        email,
        message,
        subject
      },
      'confirm'
    );
  }
}
